export const POST_CONTACT = 'POST_CONTACT';
export const LIST_CONTACT = 'LIST_CONTACT';
export const MESSAGE_ENTERPRISE = 'MESSAGE_ENTERPRISE';
